import axios from "axios";

const GET_USER_BLOGS = `  
  query GetUserArticles ($page: Int!) {  
    user (username: "sonubardai") {  
      publication {  
        posts (page: $page) {  
          title  
          brief  
          slug  
          dateAdded  
          coverImage  
          contentMarkdown  
        }  
      }  
    }  
  } 
`;

async function gql(query, variables = {}) {
  const response = await axios.post("https://api.hashnode.com/", {
    query,
    variables,
  });
  return response.data;
}

function generateBrief(content) {
  // extract the first few sentences from the content
  const sentences = content.split(/(?<=\.)/);
  const brief = sentences.slice(0, 3).join(" ");
  return brief;
}

export const fetchBlogsHashnode = async () => {
  let allBlogsFetched = false;
  let page = 0;
  const articles = [];

  while (!allBlogsFetched) {
    let response = await gql(GET_USER_BLOGS, { page: page });
    articles.push(
      ...response.data.user.publication.posts.map((post) => ({
        title: post.title,
        brief: post.brief || generateBrief(post.contentMarkdown),
        dateAdded: post.dateAdded,
        coverImage: post.coverImage,
        contentMarkdown: post.contentMarkdown,
        url: `https://sonubardai.hashnode.dev/${post.slug}`,
      }))
    );
    if (response.data.user.publication.posts.length === 0) {
      allBlogsFetched = true;
    }
    page++;
  }

  return articles;
};

export const fetchBlogsDevTo = async () => {
  const response = await axios.get(
    "https://dev.to/api/articles?username=sonubardai"
  );
  const articles = response.data.map((article) => ({
    title: article.title,
    description: article.description,
    url: article.url,
    coverImage: article.cover_image,
  }));
  return articles;
};

export const fetchBlogs = async () => {
  const hashnodeBlogs = await fetchBlogsHashnode();
  const devToBlogs = await fetchBlogsDevTo();
  return [...hashnodeBlogs, ...devToBlogs];
};
